import { render, staticRenderFns } from "./empty_state.vue?vue&type=template&id=cf06488e&vue3"
import script from "./empty_state.vue?vue&type=script&lang=js&vue3"
export * from "./empty_state.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports